import { Box, VStack } from '@chakra-ui/react';
import SidebarItem from './SidebarItem';
import SidebarHeader from './SidebarHeader';

const Sidebar = ({
  isOpen,
  onClose,
  conversations,
  activeConversationId,
  setActiveConversationId,
  setShowLoadingAnimation,
  setShowProviderLoadingScreen,
  setMessages,
  expandedView,
  isDisabled,
  setSearchResults,
}) => {
  return (
    <Box
      w={isOpen ? '350px' : '0'}
      overflow='hidden'
      bg='#FFFFFF'
      borderRadius='5px'
      borderRight='1px solid gray.200'
      transition='width 0.15s ease-in-out'
      mt={expandedView ? '0px' : '30px'}
      height={
        expandedView ? 'calc(100vh - 50px)' : 'calc(100vh - 64px - 47px - 60px)'
      } //Remove the header height, footer height, and the margin
    >
      <SidebarHeader
        onClose={onClose}
        setActiveConversationId={setActiveConversationId}
        setMessages={setMessages}
        isDisabled={isDisabled}
        setSearchResults={setSearchResults}
      />
      <Box overflowY='auto' maxH='100%'>
        <VStack align='stretch' spacing={1} p={2}>
          {conversations.map((conversation) => (
            <SidebarItem
              key={conversation.conversationId}
              conversationTitle={conversation.conversationTitle}
              conversationId={conversation.conversationId}
              isActive={activeConversationId === conversation.conversationId}
              setActiveConversationId={setActiveConversationId}
              setShowLoadingAnimation={setShowLoadingAnimation}
              setShowProviderLoadingScreen={setShowProviderLoadingScreen}
              isDisabled={isDisabled}
            />
          ))}
        </VStack>
      </Box>
    </Box>
  );
};

export default Sidebar;
